import type { IconData } from '@stacksjs/iconify-core'

export const brokenLink2: IconData = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" stroke-width=\"3\"><path d=\"m31.454 38.83l-1.522 1.523c-6.167 6.166-16.164 6.166-22.33 0c-6.167-6.166-6.167-16.164 0-22.33L9.124 16.5m14.887 14.887l-1.523 1.523a5.263 5.263 0 0 1-7.443-7.444l1.522-1.523M4 4l40 40M40.4 7.648c-6.167-6.166-16.164-6.166-22.33 0l-2.382 2.382a4 4 0 0 0 0 5.657l1.786 1.786a4 4 0 0 0 5.657 0l2.382-2.381a5.263 5.263 0 0 1 7.443 7.443l-2.382 2.382a4 4 0 0 0 0 5.657l1.787 1.786a4 4 0 0 0 5.657 0l2.382-2.382c6.166-6.166 6.166-16.164 0-22.33\"/><path d=\"m20.301 20.3l5.21-5.21a5.263 5.263 0 0 1 7.444 7.444l-5.21 5.21\"/></g>",
  "width": 48,
  "height": 48,
  "viewBox": "0 0 48 48"
}

export default brokenLink2
